module.exports = __webpack_public_path__ + "media/images/plans/proposal-schedule_5-acf95ac1718845f1cc2b89fc843abf70.jpg";